import React, { useEffect, useState, useMemo } from "react";
import Layouts from "../../components/Layouts";
import { getDirectusClient } from "../../lib/directus";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Tabs,
  message,
  Typography,
  Alert,
} from "antd";
import Seriales from "./components/Seriales";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  createItem,
  readItems,
  readUsers,
  updateItem,
  updateUser,
} from "@directus/sdk";
import PorCaja from "./components/PorCaja";
import PorCajaGrupo from "./components/PorCajaGrupo";
import moment from "moment"; // Replace dayjs import with moment
import CajaCloseModal from "./components/CajaCloseModal";
import ConsignacionModal from "./components/ConsignacionModal";

const { Option } = Select;
const { Text } = Typography;
const arrayproductosfacturar = [];
function Factura(props) {
  const dispacth = useDispatch();
  const [vendedoresprestamo, setVendedoresprestamo] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
  });

  const productofactura = useSelector((state) => state.productosfacturar);
  const [vendedorprestamo, setVendedorprestamo] = useState("");
  const [totalfactura, setTotalfactura] = useState(0);
  const [productosvendedor, setProductosvendedor] = useState([]);
  const [productotabla, setProductotabla] = useState([]);
  const [precios, setPrecios] = useState([]);

  const user = useSelector((state) => state.userdata.id);
  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const [currentCajaId, setCurrentCajaId] = useState(null);
  const userRoleID = useSelector((state) => state.userdata.role.name);
  const [precioselect, setPrecioselect] = useState(0);
  const [productoselect, setProductoselect] = useState({});

  const [seriales, setSeriales] = useState([]);
  const [form] = Form.useForm();

  const navigate = useNavigate();

  const [vendedoresFactura, setVendedoresFactura] = useState([]);
  const [cajaAbierta, setCajaAbierta] = useState(false);

  // Add new state for final total
  const [totalConImpuestos, setTotalConImpuestos] = useState(0);

  // Add new state for clients
  const [clientes, setClientes] = useState([]);

  // Add new state at the top of the component
  const [tipoFactura, setTipoFactura] = useState([]);
  const [selectedTipoFactura, setSelectedTipoFactura] = useState(null);

  // Add new state for storing complete client data
  const [selectedClient, setSelectedClient] = useState(null);

  // Add new state for the modal
  const [isCajaCloseModalVisible, setIsCajaCloseModalVisible] = useState(false);

  // Add new state for discounts
  const [descuentos, setDescuentos] = useState([]);

  // Add new state for consignacion modal
  const [isConsignacionModalVisible, setIsConsignacionModalVisible] =
    useState(false);

  // Only depends on user being available

  // Update consultarVendedorprestamo function
  const consultarVendedorprestamo = async (value) => {
    const directus = await getDirectusClient();
    const response = await directus.request(
      readUsers({
        search: value,
        fields: [
          "id",
          "first_name",
          "last_name",
          "productos_prestados.id",
          "productos_prestados.nombre",
          "productos_prestados.preciosinimp",
          "productos_prestados.precios.*",
          "productos_prestados.seriales.*",
        ],
        filter: {
          role: {
            name: {
              _contains: "vendedor",
            },
          },
          ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
            ? {
               
                  bodega: {
                    id: { _eq: userBodega },
                  },
                
              }
            : {}),
        },
      })
    );

    // Filter vendors that have products with serials in estado 1 or 3
    const filteredVendors = response.filter((vendor) => {
      return vendor.productos_prestados?.some((producto) => {
        return producto.seriales?.some(
          (serial) => serial.estado === 1 || serial.estado === 3
        );
      });
    });

    setVendedoresprestamo(filteredVendors);
  };

  const consultarVendedorFactura = async (value) => {
    const directus = await getDirectusClient();
    const response = await directus.request(
      readUsers({
        search: value,
        fields: ["id", "first_name", "last_name"],
        filter: {
          role: {
            name: {
              _contains: "vendedor",
            },
          },
          ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
            ? {
              
                  bodega: {
                    id: { _eq: userBodega },
                  },
                
              }
            : {}),
        },
      })
    );
    setVendedoresFactura(response);
  };

  // Add new function to fetch clients
  const consultarClientes = async (value) => {
    if (!value) return; // If empty search, keep showing initial data

    const directus = await getDirectusClient();
    try {
      const response = await directus.request(
        readUsers({
          search: value,
          fields: ["id", "first_name", "last_name"],
          filter: {
            role: {
              name: {
                _contains: "cliente",
              },
            },
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                
                    bodega: {
                      id: { _eq: userBodega },
                    },
                
                }
              : {}),
          },
        })
      );
      setClientes(response);
    } catch (error) {
      console.error("Error fetching clients:", error);
      message.error("Error al cargar los clientes");
    }
  };

  const processCajaStatus = async (existingCajas) => {
    if (existingCajas && existingCajas.length > 0) {
      const cajaHoy = existingCajas[0];
      const cajaDate = moment(cajaHoy.fecha_apertura);
      const today = moment().startOf("day");

      // Check if caja is from previous day and still open
      if (cajaHoy.estado === 1 && cajaDate.isBefore(today)) {
        Modal.confirm({
          title: "Caja Anterior Abierta",
          content:
            "Tiene una caja abierta del día anterior. Debe cerrarla antes de continuar.",
          okText: "Cerrar caja anterior",
          cancelText: "Cancelar",
          onOk: async () => {
            try {
              const directus = await getDirectusClient();
              await directus.request(
                updateItem("cajas", cajaHoy.id, {
                  estado: 2,
                  fecha_cierre: moment().toISOString(),
                })
              );

              message.success("Caja anterior cerrada exitosamente");
              // Show modal to open today's caja
              Modal.confirm({
                title: "Abrir Nueva Caja",
                content: "¿Desea abrir su caja para el día de hoy?",
                okText: "Sí, abrir caja",
                cancelText: "No",
                onOk: () => handleCajaOpen(),
                onCancel: () => setCajaAbierta(false),
              });
            } catch (error) {
              console.error("Error cerrando caja anterior:", error);
              Modal.error({
                title: "Error",
                content: "No se pudo cerrar la caja anterior",
              });
            }
          },
        });
        return false;
      }

      // Regular flow for today's caja
      if (cajaHoy.estado === 2) {
        Modal.error({
          title: "Caja Cerrada",
          content:
            "Su caja del día está cerrada. No puede realizar más operaciones hoy.",
        });
        setCajaAbierta(false);
        return true;
      } else {
        setCajaAbierta(true);
        return true;
      }
    }

    // No caja found, show confirmation for new caja
    Modal.confirm({
      title: "Caja Cerrada",
      content: "¿Desea abrir su caja para el día de hoy?",
      okText: "Sí, abrir caja",
      cancelText: "No",
      onOk: () => handleCajaOpen(),
      onCancel: () => setCajaAbierta(false),
    });
    return false;
  };

  // Add this as a separate function
  const handleCajaValidation = (cajas) => {
    if (!cajas || cajas.length === 0) {
      Modal.confirm({
        title: "Caja Cerrada",
        content: "¿Desea abrir su caja para el día de hoy?",
        okText: "Sí, abrir caja",
        cancelText: "No",
        onOk: () => handleCajaOpen(),
        onCancel: () => setCajaAbierta(false),
      });
      return;
    }

    const cajaActual = cajas[0];
    const cajaDate = moment(cajaActual.fecha_apertura).startOf("day");
    const today = moment().startOf("day");

    if (cajaDate.isBefore(today)) {
      Modal.confirm({
        title: "Caja Anterior Abierta",
        content: "Tiene una caja abierta del día anterior. ¿Desea cerrarla?",
        okText: "Cerrar caja anterior",
        cancelText: "Cancelar",
        onOk: async () => {
          try {
            const directus = await getDirectusClient();
            await directus.request(
              updateItem("cajas", cajaActual.id, {
                estado: 2,
                fecha_cierre: moment().toISOString(),
              })
            );

            message.success("Caja anterior cerrada exitosamente");
            Modal.confirm({
              title: "Abrir Nueva Caja",
              content: "¿Desea abrir su caja para el día de hoy?",
              okText: "Sí, abrir caja",
              cancelText: "No",
              onOk: () => handleCajaOpen(),
              onCancel: () => setCajaAbierta(false),
            });
          } catch (error) {
            console.error("Error cerrando caja anterior:", error);
            Modal.error({
              title: "Error",
              content: "No se pudo cerrar la caja anterior",
            });
          }
        },
      });
      setCajaAbierta(false);
    } else {
      setCajaAbierta(true);
    }
  };

  // Simplify useEffect to only fetch data
  useEffect(() => {
    const fetchCajaStatus = async () => {
      try {
        const directus = await getDirectusClient();
        const response = await directus.request(
          readItems("cajas", {
            fields: ["id", "fecha_apertura", "fecha_cierre", "estado"],
            filter: {
              vendedor: {
                _eq: user,
              },
              estado: {
                _eq: 1,
              },
            },
            sort: ["-fecha_apertura"],
          })
        );
        if (response && response.length > 0) {
          setCurrentCajaId(response[0].id);
        }
        handleCajaValidation(response);
      } catch (error) {
        console.error("Error verificando caja:", error);
        Modal.error({
          title: "Error",
          content: "Error al verificar el estado de la caja",
        });
      }
    };

    if (user) {
      fetchCajaStatus();
    }
  }, [user]);

  // Add new useEffect to load initial clients
  useEffect(() => {
    const loadInitialClients = async () => {
      const directus = await getDirectusClient();
      try {
        const response = await directus.request(
          readUsers({
            fields: ["id", "first_name", "last_name"],
            filter: {
              role: {
                name: {
                  _contains: "cliente",
                },
              },
              ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
                ? {
                  bodega: {
                    id: { _eq: userBodega },
                  },
                  }
                : {}),
            },
            limit: 100, // Adjust this number based on your needs
          })
        );
        setClientes(response);
      } catch (error) {
        console.error("Error loading initial clients:", error);
        message.error("Error al cargar los clientes iniciales");
      }
    };

    if (user) loadInitialClients();
  }, [user]); // Empty dependency array means this runs once when component mounts

  // Add new useEffect to load initial vendors
  useEffect(() => {
    const loadInitialVendors = async () => {
      const directus = await getDirectusClient();
      try {
        // Load prestamo vendors
        const prestamoResponse = await directus.request(
          readUsers({
            fields: [
              "id",
              "first_name",
              "last_name",
              "productos_prestados.*",
              "productos_prestados.seriales.id",
              "productos_prestados.seriales.estado",
            ],
            filter: {
              role: {
                name: {
                  _contains: "vendedor",
                },
              },
              ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
                ? {
                   
                      bodega: {
                        id: { _eq: userBodega },
                      },
                    
                  }
                : {}),
            },
            limit: 100,
          })
        );
        setVendedoresprestamo(prestamoResponse);

        // Load factura vendors
        const facturaResponse = await directus.request(
          readUsers({
            fields: ["id", "first_name", "last_name"],
            filter: {
              role: {
                name: {
                  _contains: "vendedor",
                },
              },
              ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
                ? {
                   
                      bodega: {
                        id: { _eq: userBodega },
                      },
                    
                  }
                : {}),
            },
            limit: 100,
          })
        );
        setVendedoresFactura(facturaResponse);
      } catch (error) {
        console.error("Error loading initial vendors:", error);
        message.error("Error al cargar los vendedores iniciales");
      }
    };

    loadInitialVendors();
  }, [user]); // Empty dependency array means this runs once when component mounts

  // Add new function to fetch tipo_factura
  const fetchTipoFactura = async () => {
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readItems("tipo_factura", {
          fields: ["id", "tipo"],
        })
      );
      setTipoFactura(response);
    } catch (error) {
      console.error("Error fetching tipo_factura:", error);
      message.error("Error al cargar los tipos de factura");
    }
  };

  // Add useEffect to load tipo_factura
  useEffect(() => {
    fetchTipoFactura();
  }, []);

  const handleCajaOpen = async () => {
    try {
      const directus = await getDirectusClient();
      const newCaja = await directus.request(
        createItem("cajas", {
          vendedor: user,
          fecha_apertura: moment().toISOString(),
          estado: 1,
          total_ventas: 0,
        })
      );

      if (newCaja) {
        setCurrentCajaId(newCaja.id);
        message.success("Caja abierta exitosamente");
        setCajaAbierta(true);
      }
    } catch (error) {
      console.error("Error abriendo caja:", error);
      Modal.error({
        title: "Error",
        content: "No se pudo abrir la caja",
      });
    }
  };

  // Add function to fetch discounts
  const fetchDescuentos = async (vendedorId) => {
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readItems("descuentos", {
          fields: [
            "id",
            "nombre",
            "descuento",
            "productos.id",
            "productos.nombre",
            "usuarios.directus_users_id.id",
          ],
          filter: {
            usuarios: {
              directus_users_id: {
                id: { _eq: vendedorId },
              },
            },
          },
        })
      );
      setDescuentos(response);
      return response;
    } catch (error) {
      console.error("Error fetching discounts:", error);
      return [];
    }
  };

  // Update seleccionarvendedorprestamo function
  const seleccionarvendedorprestamo = async (ev) => {
    const vendedor = vendedoresprestamo.find((item) => item.id === ev);
    console.log(vendedor);

    // Fetch discounts for this vendor
    const vendorDiscounts = await fetchDescuentos(ev);

    // Filter products that have serials in estado 1 or 3
    const filteredProducts = vendedor.productos_prestados.filter((producto) => {
      return producto.seriales?.some(
        (serial) => serial.estado === 1 || serial.estado === 3
      );
    });

    setVendedorprestamo(vendedor);
    setProductosvendedor(filteredProducts);
  };

  const selecionadoproducto = (ev) => {
    const pro = productosvendedor.find((item) => item.id === ev);
    let preciosArray = [];

    form.resetFields(["precios"]);

    if (!pro) {
      console.error("Producto no encontrado");
      return;
    }

    // Add the initial price
    preciosArray.push({
      precio: pro.preciosinimp,
      alias: "precioinicial",
      estado: true,
    });

    // Add additional prices if they exist and are active
    if (pro.precios && Array.isArray(pro.precios)) {
      pro.precios.forEach((p) => {
        if (p.estado === true) {
          preciosArray.push({
            precio: p.precio,
            alias: p.alias,
            estado: p.estado,
          });
        }
      });
    }

    // Set the prices state with the new array
    setPrecios(preciosArray);

    // Set the selected product
    setProductoselect({
      ...pro,
      id: pro.id,
      nombre: pro.nombre,
    });

    console.log("Product selected:", pro);
    console.log("Available prices:", preciosArray);
  };

  // Modify selectprecio function to correctly apply discounts
  const selectprecio = (ev) => {
    const newPrice = parseFloat(ev);
    setPrecioselect(newPrice);

    // Update only the current product's price
    if (productoselect && productoselect.id) {
      const existingProduct = arrayproductosfacturar.find(
        (item) => item.producto.id === productoselect.id
      );

      if (existingProduct) {
        existingProduct.precio = newPrice;
        // Find discount for this specific product
        const discount = descuentos.find(
          (d) => d.productos && d.productos.id === productoselect.id
        );

        if (discount) {
          existingProduct.descuento = parseFloat(discount.descuento);
        }
      }
    }

    updateTableData();
  };

  const [loading, setLoading] = useState(false);

  // Update consultarserialesvendedor function
  const consultarserialesvendedor = async () => {
    setLoading(true);
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readItems("seriales", {
          meta: "*",
          fields: [
            "*",
            "producto.grupo.impuesto",
            "producto.id",
            "grupo.*",
            "producto.name",
          ],
          limit: pagination.pageSize,
          page: pagination.current,
          filter: {
            _and: [
              {
                user: {
                  id: { _eq: vendedorprestamo.id },
                },
              },
              {
                producto: {
                  id: { _eq: productoselect.id },
                },
              },
              {
                estado: {
                  id: { _in: [1, 3] }, // Only estados 1 or 3
                },
              },
              {
                ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
                  ? {
                     
                        bodega: {
                          id: { _eq: userBodega },
                        },
                   
                    }
                  : {}),
              },
            ],
          },
        })
      );

      setSeriales(response);
      setPagination((prevPagination) => ({
        ...prevPagination,
        total: response.filter_count,
      }));
    } catch (error) {
      console.error("Error fetching seriales:", error);
      message.error("Error al cargar los seriales");
    } finally {
      setLoading(false);
    }
  };

  const agregarserial = (serial, checked, showMessage = true) => {
    const serialDetails = seriales.find((item) => item.id === serial);

    if (!serialDetails) {
      console.error("Serial no encontrado");
      return;
    }

    // Check if serial is already selected in any product
    const isSerialAlreadySelected = arrayproductosfacturar.some((item) =>
      item.seriales.some((s) => s.id === serial)
    );

    if (checked && isSerialAlreadySelected) {
      message.warning("Este serial ya ha sido seleccionado");
      return;
    }

    if (checked) {
      // If producto is not selected, select it
      if (
        !productoselect.id ||
        productoselect.id !== serialDetails.producto.id
      ) {
        const producto = productosvendedor.find(
          (p) => p.id === serialDetails.producto.id
        );

        if (producto) {
          form.setFieldsValue({
            producto: producto.id,
          });
          selecionadoproducto(producto.id);
        }
      }

      let found = arrayproductosfacturar.find(
        (item) => item.producto.id === serialDetails.producto.id
      );

      if (found) {
        const serialExists = found.seriales.find((item) => item.id === serial);
        if (!serialExists) {
          found.seriales.push(serialDetails);
          // Show message only for individual serial additions if showMessage is true
          if (showMessage) {
            message.success(
              `Se agregó el serial del producto ${found.producto.nombre}`
            );
          }
        }
      } else {
        const selectedProduct = productosvendedor.find(
          (p) => p.id === serialDetails.producto.id
        );
        arrayproductosfacturar.push({
          producto: {
            id: serialDetails.producto.id,
            nombre: selectedProduct?.nombre || serialDetails.producto.name,
          },
          seriales: [serialDetails],
          precio: precioselect || 0,
        });
        // Show message only for individual serial additions if showMessage is true
        if (showMessage) {
          message.success(
            `Se agregó el serial del producto ${
              selectedProduct?.nombre || serialDetails.producto.name
            }`
          );
        }
      }
    }

    updateTableData();
  };

  // Modify updateTableData function to correctly handle discounts
  const updateTableData = () => {
    const newTableData = arrayproductosfacturar.map((item) => {
      // Find discount for this specific product
      const discount = descuentos.find(
        (d) => d.productos && d.productos.id === item.producto.id
      );

      const impuesto = item.seriales[0]?.producto?.grupo?.impuesto || 0;
      const descuentoPorcentaje = discount ? parseFloat(discount.descuento) : 0;
      const precioOriginal = item.precio || precioselect;

      // Calculate discount amount for this specific product
      const descuentoAmount = (precioOriginal * descuentoPorcentaje) / 100;
      const precioConDescuento = precioOriginal - descuentoAmount;

      // Calculate totals
      const subtotal = precioConDescuento * item.seriales.length;
      const impuestoValue = subtotal * (impuesto / 100);

      console.log("Product calculations:", {
        productId: item.producto.id,
        productName: item.producto.nombre,
        originalPrice: precioOriginal,
        discount: descuentoPorcentaje,
        priceAfterDiscount: precioConDescuento,
        quantity: item.seriales.length,
        subtotal: subtotal,
      });

      return {
        key: item.producto.id,
        producto: item.producto.nombre,
        cantidad: item.seriales.length,
        precio: precioOriginal,
        descuento: descuentoPorcentaje,
        precioConDescuento: precioConDescuento,
        impuesto: `${impuesto}%`,
        subtotal: subtotal,
        totalConImpuesto: subtotal + impuestoValue,
      };
    });

    const subtotal = newTableData.reduce((sum, item) => sum + item.subtotal, 0);
    const totalFinal = newTableData.reduce(
      (sum, item) => sum + item.totalConImpuesto,
      0
    );

    setTotalfactura(subtotal);
    setTotalConImpuestos(totalFinal);
    setProductotabla([...newTableData]);
  };

  const addarray = async (array) => {
    await setProductotabla(array);
  };

  const items = [
    {
      key: "1",
      label: `Por Seriales`,
      children: (
        <Seriales
          productoselect={productoselect}
          seriales={seriales}
          setPagination={setPagination}
          current={pagination.current}
          totalpagina={pagination.total}
          agregarserial={agregarserial}
          onFetchSeriales={consultarserialesvendedor}
          loading={loading}
          arrayproductosfacturar={arrayproductosfacturar}
        />
      ),
    },
    {
      key: "2",
      label: `Por caja`,
      children: (
        <PorCaja
          productoselect={productoselect}
          seriales={seriales}
          agregarPorCaja={agregarserial}
          onFetchSeriales={consultarserialesvendedor}
          loading={loading}
          arrayproductosfacturar={arrayproductosfacturar}
        />
      ),
    },
    {
      key: "3",
      label: `Por caja y grupo`,
      children: (
        <PorCajaGrupo
          productoselect={productoselect}
          seriales={seriales}
          agregarPorCajaGrupo={agregarserial}
          arrayproductosfacturar={arrayproductosfacturar}
        />
      ),
    },
  ];

  // Add a new function to handle product removal
  const handleRemoveProduct = (productId) => {
    const index = arrayproductosfacturar.findIndex(
      (item) => item.producto.id === productId
    );
    if (index > -1) {
      arrayproductosfacturar.splice(index, 1);
      updateTableData();
      message.success("Producto eliminado");
    }
  };

  // Modify columns array to show discount information
  const columns = [
    {
      title: "Producto",
      dataIndex: "producto",
      key: "producto",
    },
    {
      title: "Cantidad",
      dataIndex: "cantidad",
      key: "cantidad",
    },
    {
      title: "Precio",
      dataIndex: "precio",
      key: "precio",
      render: (value) => `$${value.toLocaleString()}`,
    },
    {
      title: "Descuento",
      dataIndex: "descuento",
      key: "descuento",
      render: (value) => (value ? `${value}%` : "0%"),
    },
    {
      title: "Precio con Descuento",
      dataIndex: "precioConDescuento",
      key: "precioConDescuento",
      render: (value) => `$${value.toLocaleString()}`,
    },
    {
      title: "Impuesto",
      dataIndex: "impuesto",
      key: "impuesto",
    },
    {
      title: "Subtotal",
      dataIndex: "subtotal",
      key: "subtotal",
      render: (value) => `$${value.toLocaleString()}`,
    },
    {
      title: "Total + Imp",
      dataIndex: "totalConImpuesto",
      key: "totalConImpuesto",
      render: (value) => `$${value.toLocaleString()}`,
    },
    {
      title: "Acciones",
      key: "action",
      render: (_, record) => (
        <Button
          type="text"
          danger
          onClick={() => handleRemoveProduct(record.key)}
        >
          Eliminar
        </Button>
      ),
    },
  ];

  // Add new helper function for credit validations

  const handleClienteChange = async (clienteId) => {
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readUsers({
          fields: [
            "id",
            "credito",
            "first_name",
            "last_name",
            "tope_credito",
            "credito_usado",
            "fecha_credito_acreditado",
            "dias_max_credito",
          ],
          filter: {
            id: { _eq: clienteId },
          },
        })
      );

      if (response && response[0]) {
        const clientData = response[0];
        setSelectedClient(clientData);

        form.setFieldsValue({ tipo_factura: undefined });
        setSelectedTipoFactura(null);

        if (!clientData.credito) {
          setSelectedTipoFactura(1);
          form.setFieldsValue({ tipo_factura: 1 });
          message.warning(
            "Este cliente no tiene crédito habilitado - solo facturas de cobro"
          );
          return;
        }

        // Check credit days if there's an active credit
        if (clientData.fecha_credito_acreditado) {
          const creditDate = moment(clientData.fecha_credito_acreditado);
          const daysElapsed = moment().diff(creditDate, "days");

          if (daysElapsed > clientData.dias_max_credito) {
            message.warning(
              `Cliente ha superado el límite de días de crédito (${clientData.dias_max_credito} días)`
            );
          }
        }

        // Check available credit
        const currentCreditUsed = parseFloat(clientData.credito_usado || 0);
        const creditLimit = parseFloat(clientData.tope_credito || 0);
        const availableCredit = creditLimit - currentCreditUsed;

        if (availableCredit <= 0) {
          message.warning("Cliente ha alcanzado su tope de crédito");
        } else {
          message.info(
            `Crédito disponible: $${availableCredit.toLocaleString()}`
          );
        }
      }
    } catch (error) {
      console.error("Error checking client credit:", error);
      message.error("Error al verificar el crédito del cliente");
    }
  };

  // Add credit validation function
  const validateCredit = async (clientData, invoiceAmount) => {
    // Check if client has credit enabled
    if (!clientData.credito) {
      throw new Error("Este cliente no tiene crédito habilitado");
    }

    // Check credit limit
    const currentCreditUsed = parseFloat(clientData.credito_usado || 0);
    const creditLimit = parseFloat(clientData.tope_credito || 0);
    const newCreditTotal = currentCreditUsed + invoiceAmount;

    if (newCreditTotal > creditLimit) {
      throw new Error(
        `El cliente superaría su tope de crédito (${creditLimit.toLocaleString()})`
      );
    }

    // Check credit days if there's an active credit
    if (clientData.fecha_credito_acreditado) {
      const creditDate = moment(clientData.fecha_credito_acreditado);
      const daysElapsed = moment().diff(creditDate, "days");

      if (daysElapsed > clientData.dias_max_credito) {
        throw new Error(
          `El cliente ha superado su límite de días de crédito (${clientData.dias_max_credito} días)`
        );
      }
    }

    return true;
  };

  // Update the Facturar function
  const Facturar = async () => {
    try {
      if (!cajaAbierta) {
        Modal.error({
          title: "Caja Cerrada",
          content: "No puede crear facturas sin tener una caja abierta.",
        });
        return;
      }

      const formValues = form.getFieldsValue();
      console.log("Factura", formValues);

      const directus = await getDirectusClient();
      let productos = [];
      let allSeriales = [];
      let totalVenta = 0;
      const currentDate = moment().format("YYYY-MM-DDTHH:mm:ssZ");

      // Calculate total and prepare productos data
      arrayproductosfacturar.forEach((item) => {
        totalVenta += item.precio * item.seriales.length;

        productos.push({
          nombre: item.producto.nombre,
          cantidad: item.seriales.length,
          precio_unitario: item.precio,
          producto: item.producto.id,
          seriales: item.seriales.map((serial) => ({
            id: serial.id,
          })),
        });

        allSeriales.push(...item.seriales.map((s) => s.id));
      });

      if (formValues.tipo_factura === 2) {
        try {
          const directus = getDirectusClient();
          const clientResponse = await directus.request(
            readUsers({
              fields: [
                "id",
                "credito",
                "credito_usado",
                "tope_credito",
                "fecha_credito_acreditado",
                "dias_max_credito",
              ],
              filter: { id: { _eq: formValues.cliente } },
            })
          );

          const clientData = clientResponse[0];

          if (!clientData) {
            throw new Error("Cliente no encontrado");
          }

          await validateCredit(clientData, totalConImpuestos);
        } catch (error) {
          Modal.error({
            title: "Error de Crédito",
            content: error.message,
          });
          return;
        }
      }

      // Create factura regardless of type
      const facturaResponse = await directus.request(
        createItem("facturas", {
          vendedor_prestamo: vendedorprestamo.id,
          vendedor_factura: formValues.vendedor_factura,
          cliente: formValues.cliente,
          tipo: formValues.tipo_factura,
          prefijo: "PRE",
          total: totalVenta,
          productos: productos,
          caja: currentCajaId,
          bodega: userBodega,
        })
      );

      if (facturaResponse.id) {
        // Update prestamo_usado for vendor
        await directus.request(
          updateUser(vendedorprestamo.id, {
            prestamo_usado:
              parseFloat(vendedorprestamo.prestamo_usado || 0) +
              totalConImpuestos,
          })
        );

        if (formValues.tipo_factura === 2) {
          // Convert the values to numbers and calculate the new credit
          const currentCreditUsed = parseFloat(
            selectedClient.credito_usado || 0
          );
          const newCreditAmount = parseFloat(totalConImpuestos);
          const newCreditUsed = (currentCreditUsed + newCreditAmount).toFixed(
            2
          );

          await directus.request(
            updateUser(formValues.cliente, {
              credito_usado: parseFloat(newCreditUsed), // Convert back to number after fixing decimals
              ...((!selectedClient.fecha_credito_acreditado ||
                selectedClient.fecha_credito_acreditado === null) && {
                fecha_credito_acreditado: currentDate,
              }),
            })
          );
        }

        await Promise.all([
          directus.request(
            createItem("historial_seriales", {
              tipo: 1,
              factura_n: facturaResponse.id,
              seriales: {
                create: allSeriales.map((serialId) => ({
                  historial_seriales_id: "+",
                  seriales_id: {
                    id: serialId,
                  },
                })),
              },
            })
          ),
          ...allSeriales.map((serialId) =>
            directus.request(
              updateItem("seriales", serialId, {
                estado: 2, // estado facturado
                user: null, // Limpiar el usuario
                factura: facturaResponse.id, // Asignar la factura
              })
            )
          ),
        ]);

        message.success("Factura creada exitosamente");
        navigate("/visualizarfactura", {
          state: {
            factura: facturaResponse,
          },
        });
      }
    } catch (error) {
      console.error("Error creating factura:", error);
      Modal.error({
        title: "Error",
        content: "Error al crear la factura",
      });
    }
  };

  const cerrarCaja = () => {
    setIsCajaCloseModalVisible(true);
  };

  // Add this check before rendering tabs
  const showTabs = useMemo(() => {
    return productoselect.id && precioselect > 0;
  }, [productoselect.id, precioselect]);

  return (
    <Layouts>
      <Form form={form} onFinish={Facturar}>
        <Row gutter={16}>
          <Col>
            {" "}
            <Form.Item
              name="vendedor"
              label="Vendedor prestamo"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Selecciona un vendedor"
                showSearch
                filterOption={(input, option) => {
                  const label = `${option?.label || ""}`;
                  return label.toLowerCase().includes(input.toLowerCase());
                }}
                onSearch={consultarVendedorprestamo}
                onChange={seleccionarvendedorprestamo}
                style={{ width: 200 }}
              >
                {vendedoresprestamo.map((vendedor) => (
                  <Option
                    key={vendedor.id}
                    value={vendedor.id}
                    label={`${vendedor.first_name} ${vendedor.last_name}`}
                  >
                    {vendedor.first_name}
                    <span style={{ color: "#20c77c", fontSize: 12 }}>
                      {" "}
                      {vendedor.last_name}
                    </span>
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="vendedor_factura"
              label="Vendedor factura"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Selecciona un vendedor"
                showSearch
                filterOption={(input, option) => {
                  const label = `${option?.label || ""}`;
                  return label.toLowerCase().includes(input.toLowerCase());
                }}
                onSearch={consultarVendedorFactura}
                style={{ width: 200 }}
              >
                {vendedoresFactura.map((vendedor) => (
                  <Option
                    key={vendedor.id}
                    value={vendedor.id}
                    label={`${vendedor.first_name} ${vendedor.last_name}`}
                  >
                    {vendedor.first_name}
                    <span style={{ color: "#20c77c", fontSize: 12 }}>
                      {" "}
                      {vendedor.last_name}
                    </span>
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="producto"
              label="Seleccione un producto"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Selecciona un Producto"
                filterOption={false}
                onChange={selecionadoproducto}
                style={{ width: 200 }}
              >
                {productosvendedor.map((producto) => (
                  <Option key={producto.id} value={producto.id} allowClear>
                    {producto.nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="precios"
              label="Seleccione precio de producto"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Selecciona un Precio"
                showSearch={true}
                filterOption={false}
                onChange={selectprecio}
                style={{ width: 200 }}
              >
                {precios.map((precio) => (
                  <Option key={precio.alias} value={precio.precio} allowClear>
                    {`${precio.alias}   ${precio.precio}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="cliente"
              label="Cliente"
              rules={[
                { required: true, message: "Por favor seleccione un cliente" },
              ]}
            >
              <Select
                placeholder="Seleccione un cliente"
                showSearch
                filterOption={(input, option) =>
                  (option?.children ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onSearch={consultarClientes}
                onChange={handleClienteChange}
                style={{ width: 200 }}
              >
                {clientes.map((cliente) => (
                  <Option key={cliente.id} value={cliente.id}>
                    {`${cliente.first_name} ${cliente.last_name}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="tipo_factura"
              label="Tipo de Factura"
              rules={[
                {
                  required: true,
                  message: "Por favor seleccione el tipo de factura",
                },
              ]}
            >
              <Select
                placeholder="Seleccione el tipo de factura"
                value={selectedTipoFactura}
                onChange={(value) => setSelectedTipoFactura(value)}
                style={{ width: 200 }}
              >
                {tipoFactura.map((tipo) => {
                  const isDisabled =
                    tipo.tipo === "credito" && !selectedClient?.credito;

                  return (
                    <Option key={tipo.id} value={tipo.id} disabled={isDisabled}>
                      {tipo.tipo}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col>
            {showTabs ? (
              <Tabs defaultActiveKey="1" items={items} />
            ) : (
              <Alert
                message="Selección requerida"
                description="Por favor seleccione un producto y un precio para ver las opciones de seriales"
                type="info"
                showIcon
              />
            )}
          </Col>
        </Row>
        <Table
          columns={columns}
          dataSource={productotabla}
          rowKey="key" // Add this line
          pagination={false} // Optional, depending on your needs
        />
        <Row justify="end" style={{ marginTop: 16 }}>
          <Col>
            <Space
              direction="vertical"
              size="small"
              style={{ textAlign: "right" }}
            >
              <Text>Subtotal: ${totalfactura.toLocaleString()}</Text>
              <Text type="success">
                Total + Imp: ${totalConImpuestos.toLocaleString()}
              </Text>
            </Space>
          </Col>
        </Row>
        <Space>
          <Button type="primary" htmlType="submit" disabled={!cajaAbierta}>
            Facturar
          </Button>
          <Button
            type="primary"
            onClick={() => setIsConsignacionModalVisible(true)}
            disabled={!cajaAbierta}
          >
            Nueva Consignación
          </Button>
          <Button onClick={cerrarCaja} disabled={!cajaAbierta} danger>
            Cerrar Caja
          </Button>
        </Space>
      </Form>
      <CajaCloseModal
        visible={isCajaCloseModalVisible}
        onClose={() => setIsCajaCloseModalVisible(false)}
        cajaId={currentCajaId}
        onCajaClosed={() => {
          setCajaAbierta(false);
          setCurrentCajaId(null);
        }}
      />
      <ConsignacionModal
        visible={isConsignacionModalVisible}
        onCancel={() => setIsConsignacionModalVisible(false)}
        currentCajaId={currentCajaId}
      />
    </Layouts>
  );
}

export default Factura;
